import DashboardView from './DashboardView.vue';
//import DashboardViewHeader from './DashboardViewHeader.vue';
import ViewHeader from '@/views/ViewHeader.vue';

export default function ({ path, viewConfig, configIdentifier }) {
  let routes = [
    {
      path: `/${path}`,
      name: path,
      title: viewConfig.title,
      // meta: { type: 'View', viewConfig, baseRoute: true, configIdentifier, hideToolbar: viewConfig.hideToolbarExtension },
      meta: {
        type: 'View',
        viewConfig,
        baseRoute: true,
        configIdentifier,
        isRouterViewFixed: true,

        // that leads to a one row header on pages other than home
        // however this should be refactored, by using a different header for home screen
        // oneRowToolbar:false // path.length > 1,
      },
      components: { default: DashboardView, header: ViewHeader },
    },
  ];

  return routes;
}
